module.exports = __webpack_public_path__ + "img/blhsg03_center_003.b0002f7d.png";